import Client from "./Clients/AxiosClient";
const resource = "/api/v1/admin/paket-tryout";

export default {
  get(payload) {
    return Client.get(resource, {
      params: {
        page: payload.page || 1,
        page_size: payload.page_size || 10,
        search: payload.search || "",
        kategori_tryout: payload.kategori_tryout || "",
      },
    });
  },
  show(id) {
    return Client.get(`${resource}/${id}`);
  },
  create(payload) {
    return Client.post(`${resource}`, payload);
  },
  update(id, payload) {
    return Client.put(`${resource}/${id}`, payload);
  },
  delete(id) {
    return Client.delete(`${resource}/${id}`);
  },

  getRankingList({ paket_tryout_id, page = 1, page_size = 10, search = "" }) {
    return Client.get(`/api/v1/admin/paket-tryout/ranking/${paket_tryout_id}`, {
      params: {
        page,
        page_size,
        search,
      },
    });
  },
};
